export class OrderLineItemMaskConfig {
    public static readonly rate = {
        mask: Number,
        scale: 2,
        signed: true,
        thousandsSeparator: ',',
        padFractionalZeros: true,
        normalizeZeros: true,
        radix: '.',
        mapToRadix: ['.'],
        min: -999999999.99,
        max: 999999999.99,
    };

    public static readonly quantity = {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: ',',
        padFractionalZeros: false,
        normalizeZeros: true,
        radix: '.',
        mapToRadix: ['.'],
        min: 0,
        max: 999999999.99,
    };
}
